import styled from 'styled-components';

export const AreaMapContainer = styled.div`
  position: relative;
  text-align: center;
  display: inline-block;

  & > img {
    height: 900px;
  }
`;